import { useState } from "react";

// REGLA: 10 puntos = $1 de descuento — ajusta aquí
const POINTS_PER_PESO = 10;

export default function LoyaltyRedeemModal({ customer, onRedeem, onClose }) {
  const [pointsInput, setPointsInput] = useState("");
  const [error, setError] = useState("");

  const maxPoints = customer.points;
  const pointsToUse = parseInt(pointsInput) || 0;
  const discount = (pointsToUse / POINTS_PER_PESO).toFixed(2);

  const handleRedeem = async () => {
    if (pointsToUse <= 0) { setError("Ingresa los puntos a canjear"); return; }
    if (pointsToUse > maxPoints) { setError("Puntos insuficientes"); return; }

    const res = await fetch("/api/loyalty/redeem.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_id: customer.id,
        points: pointsToUse,
        concept: `Canje — descuento $${discount}`
      })
    });
    const data = await res.json();
    if (data.success) {
      onRedeem({ points: pointsToUse, discount: parseFloat(discount) });
    } else {
      setError(data.error || "Error al canjear");
    }
  };

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 200
    }}>
      <div style={{
        background: "#fff", borderRadius: 14, padding: 24,
        width: 300, boxShadow: "0 8px 32px rgba(0,0,0,0.2)"
      }}>
        <h3 style={{ margin: "0 0 4px", color: "#3F1907" }}>Canjear puntos</h3>
        <p style={{ margin: "0 0 16px", color: "#555", fontSize: 14 }}>
          {customer.name} tiene <strong>{maxPoints} pts</strong>
        </p>

        <label style={{ fontSize: 13, color: "#555" }}>Puntos a canjear</label>
        <input
          type="number"
          value={pointsInput}
          onChange={e => { setPointsInput(e.target.value); setError(""); }}
          max={maxPoints}
          min={1}
          style={{
            width: "100%", padding: "9px 12px", borderRadius: 8,
            border: "1px solid #ccc", fontSize: 15, marginTop: 4,
            marginBottom: 8, boxSizing: "border-box"
          }}
        />

        {pointsToUse > 0 && (
          <div style={{
            background: "#f0f9f0", border: "1px solid #58735A",
            borderRadius: 8, padding: "8px 12px", marginBottom: 12,
            fontSize: 14, color: "#3a5a3a"
          }}>
            💚 Descuento: <strong>${discount}</strong>
          </div>
        )}

        {error && (
          <div style={{ color: "#c0392b", fontSize: 13, marginBottom: 8 }}>{error}</div>
        )}

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={onClose} style={{
            flex: 1, padding: "10px 0", borderRadius: 8,
            border: "1px solid #ccc", background: "#fff",
            cursor: "pointer", fontSize: 14
          }}>Cancelar</button>
          <button onClick={handleRedeem} style={{
            flex: 1, padding: "10px 0", borderRadius: 8,
            border: "none", background: "#3F1907",
            color: "#fff", cursor: "pointer", fontSize: 14, fontWeight: 600
          }}>Canjear</button>
        </div>
      </div>
    </div>
  );
}